// apps/client/src/ui/screens/boot.tsx — wordmark + spinner (also shown while connecting / update required)
import { t } from '@whiskerton/content';
import type { ScreenDef } from '../router';
declare module '../router' { interface ScreenParams { boot: undefined } }
function Boot() {
  return (
    <div className="layer-full hit" style={{ display: 'grid', placeItems: 'center' }}>
      <div className="boot-card" style={{ textAlign: 'center' }}>
        <h1 style={{ fontWeight: 900, fontSize: 'clamp(54px, 6.6vw, 94px)', letterSpacing: '-0.025em', margin: 0, textShadow: '0 .045em .09em rgba(74,58,44,.2)' }}>{t('common.appName')}</h1>
        <p aria-live="polite">{t('common.loading')}</p>
      </div>
    </div>
  );
}
export const screen: ScreenDef<'boot'> = { id: 'boot', layer: 'full', component: Boot };
